import { createContext } from 'react';
import { LDClient } from 'launchdarkly-js-client-sdk';

export interface ILDFlagData {
  flagName: string;
  flagInExperiment: boolean;
  flagValue: boolean | string;
}

export interface Client {
  ldClient: LDClient;
}

export const ChrLdContext = createContext({} as Client);
